import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ApplicationController } from '@core/application';
import { AppConfigService } from '@core/services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard {

  readonly #router = inject(Router);
  readonly #appConfigService = inject(AppConfigService);
  readonly #appController = inject(ApplicationController);

  constructor() { }

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const loginRedirect = this.#appConfigService.get('loginRedirect');

    if (this.#appController.isAuthenticated && state.url.includes(loginRedirect)) {
      this.#router.navigate([this.#appConfigService.get('baseRouteRedirect')]);
      return false;
    }

    if (this.#appController.isAuthenticated) { return true; }
    if (state.url.includes(loginRedirect)) { return true; }

    this.#router.navigate([loginRedirect]);

    return false;
  }
}
